import { Select } from '@avanta/shared/components/ui/Select';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AppointmentsReservePayload } from 'pages/AppointmentsReserve/constants';
import { type AppointmentsReserveFormData } from 'pages/AppointmentsReserve/types';
import { type ContractSelectsProps } from './types';

export const ContractSelects = ({
  contractOptions,
  rateOptions,
  readOnlyContract = false,
  readOnlyRate = false,
  onContractChange,
  onRateChange,
}: ContractSelectsProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { control } = useFormContext<AppointmentsReserveFormData>();
  const [contractId, contractRateId] = useWatch({
    control,
    name: [AppointmentsReservePayload.contractId, AppointmentsReservePayload.contractRateId],
  });

  return (
    <>
      <Select
        label={t('AppointmentsReserve.Steps.data.administrative.contract.label')}
        options={contractOptions}
        placeholder={t('AppointmentsReserve.Steps.data.administrative.contract.placeholder')}
        required
        value={contractId}
        readOnly={readOnlyContract}
        onValueChange={onContractChange}
      />
      <Select
        label={t('AppointmentsReserve.Steps.data.administrative.rate.label')}
        options={rateOptions}
        placeholder={t('AppointmentsReserve.Steps.data.administrative.rate.placeholder')}
        required
        value={contractRateId}
        disabled={!contractId}
        readOnly={readOnlyRate}
        onValueChange={onRateChange}
      />
    </>
  );
};
